export const themeConfig = {
  flysync: {
    'color-primary-default': '#003067',
    'color-primary-light': '#fce9ec',
    'color-background': '#f3f4f8',
    'color-secondary-default': '#ff8210',
    'color-secondary-light': '#f6f9fc',
    'color-tertiary-default': '#eae0e100',
    'color-tab-background': '#1e2a38',
    'color-tertiary-light': '#eeeeee',
    'color-dark': '#000',
    'color-negative': '#ffcfcf',
    'color-border-light': '#e1e1e1',
    'color-warning': '#fff6c4',
    'color-positive': '#d9fdc1',
    'color-info': '#c6e8fa',
    'color-overlay': 'rgba(0, 0, 0, 0.05)',
    'color-text-primary': '#252525',
    'color-text-secondary': '#27272a',
    'color-text-tertiary': '#27272a',
    'color-ticket-background-light': '#EA233026',
    'color-text-foreground': '#fff',
    background: '0 0% 100%',
  },
  travelOne: {
    'color-primary-default': '#0093b4',
    'color-primary-light': '#dbeeff',
    'color-background': '#f3f4f8',
    'color-secondary-default': '#ff8210',
    'color-secondary-light': '#f6f9fc',
    'color-tertiary-default': '#484848',
    'color-tab-background': '#1e2a38',
    'color-tertiary-light': '#eeeeee',
    'color-dark': '#000',
    'color-negative': '#ffcfcc',
    'color-border-light': '#e1e1e1',
    'color-warning': '#fff6c4',
    'color-positive': '#d9fdc1',
    'color-info': '#c6e8fa',
    'color-overlay': 'rgba(0, 0, 0, 0.05)',
    'color-text-primary': '#252525',
    'color-text-secondary': '#27272a',
    'color-text-tertiary': '#27272a',
    'color-ticket-background-light': '#EA233026',
    'color-text-foreground': '#fff',
    background: '0 0% 100%',
  },
  Helinto: {
    'color-primary-default': '#e11e41',
    'color-primary-light': '#dbeeff',
    'color-background': '#f3f4f8',
    'color-secondary-default': '#ff8210',
    'color-secondary-light': '#f6f9fc',
    'color-tertiary-default': '#484848',
    'color-tab-background': '#1e2a38',
    'color-tertiary-light': '#eeeeee',
    'color-dark': '#000',
    'color-negative': '#ffcfcc',
    'color-border-light': '#e1e1e1',
    'color-warning': '#fff6c4',
    'color-positive': '#d9fdc1',
    'color-info': '#c6e8fa',
    'color-overlay': 'rgba(0, 0, 0, 0.05)',
    'color-text-primary': '#252525',
    'color-text-secondary': '#8e8e8e',
    'color-text-tertiary': '#c5c5c5',
    'color-ticket-background-light': '#EA233026',
    'color-text-foreground': '#ffff',
    background: '0 0% 100%',
  },
  makevoyage: {
    'color-primary-default': '#e11e41',
    'color-primary-light': '#fce9ec',
    'color-background': '#f3f4f8',
    'color-secondary-default': '#ff8210',
    'color-secondary-light': '#f6f9fc',
    'color-tertiary-default': '#484848',
    'color-tab-background': '#1e2a38',
    'color-tertiary-light': '#eeeeee',
    'color-dark': '#000',
    'color-negative': '#ffcfcc',
    'color-border-light': '#c6c6c6',
    'color-warning': '#fff6c4',
    'color-positive': '#d9fdc1',
    'color-info': '#c6e8fa',
    'color-overlay': 'rgba(0, 0, 0, 0.05)',
    'color-text-primary': '#252525',
    'color-text-secondary': '#27272a',
    'color-text-tertiary': '#27272a',
    'color-ticket-background-light': '#EA233026',
    'color-text-foreground': '#fff',
    background: '0 0% 100%',
  },
  Rajesh: {
    'color-primary-default': '#690776',
    'color-primary-light': '#fdefffff',
    'color-background': '#f3f4f8',
    'color-secondary-default': '#ff8210',
    'color-secondary-light': '#f6f9fc',
    'color-tertiary-default': '#484848',
    'color-tab-background': '#1e2a38',
    'color-tertiary-light': '#eeeeee',
    'color-dark': '#000',
    'color-negative': '#ffcfcc',
    'color-border-light': '#e1e1e1',
    'color-warning': '#fff6c4',
    'color-positive': '#d9fdc1',
    'color-info': '#c6e8fa',
    'color-overlay': 'rgba(0, 0, 0, 0.05)',
    'color-text-primary': '#252525',
    'color-text-secondary': '#8e8e8e',
    'color-text-tertiary': '#c5c5c5',
    'color-ticket-background-light': '#EA233026',
    'color-text-foreground': '#ffff',
    background: '0 0% 100%',
  },
  DMCLeisure: {
    'color-primary-default': '#1068b2',
    'color-primary-light': '#58A6FF',
    'color-background': '#F6FBFF',
    'color-secondary-default': '#FFCA05',
    'color-secondary-light': '#10B0E6',
    'color-tertiary-default': '#484848',
    'color-tab-background': '#1068b2',
    'color-tertiary-light': '#eeeeee',
    'color-dark': '#000',
    'color-negative': '#ffcfcc',
    'color-border-light': '#c6c6c6',
    'color-warning': '#fff6c4',
    'color-positive': '#d9fdc1',
    'color-info': '#c6e8fa',
    'color-overlay': 'rgba(0, 0, 0, 0.05)',
    'color-text-primary': '#252525',
    'color-text-secondary': '#27272a',
    'color-text-tertiary': '#27272a',
    'color-ticket-background-light': '#EFEFEF',
    'color-text-foreground': '#fff',
    background: '0 0% 100%',
  },
  Goimomi: {
    'color-primary-default': '#004B24',
    'color-primary-light': '#004b2438',
    'color-background': '#F5F5F5',
    'color-secondary-default': '#00A650',
    'color-secondary-light': '#00A650',
    'color-tertiary-default': '#484848',
    'color-tab-background': '#004B24',
    'color-tertiary-light': '#eeeeee',
    'color-dark': '#000',
    'color-negative': '#ffcfcc',
    'color-border-light': '#c6c6c6',
    'color-warning': '#fff6c4',
    'color-positive': '#d9fdc1',
    'color-info': '#c6e8fa',
    'color-overlay': 'rgba(0, 0, 0, 0.05)',
    'color-text-primary': '#252525',
    'color-text-secondary': '#27272a',
    'color-text-tertiary': '#27272a',
    'color-ticket-background-light': '#EFEFEF',
    'color-text-foreground': '#fff',
    background: '0 0% 100%',
  },
  Trailfinder: {
    'color-primary-default': '#00A650',
    'color-primary-light': '#00A65038',
    'color-background': '#f3f4f8',
    'color-secondary-default': '##F7653A',
    'color-secondary-light': '#F7653A38',
    'color-tertiary-default': '#484848',
    'color-tab-background': '#00A650',
    'color-tertiary-light': '#eeeeee',
    'color-dark': '#000',
    'color-negative': '#ffcfcc',
    'color-border-light': '#c6c6c6',
    'color-warning': '#fff6c4',
    'color-positive': '#d9fdc1',
    'color-info': '#c6e8fa',
    'color-overlay': 'rgba(0, 0, 0, 0.05)',
    'color-text-primary': '#252525',
    'color-text-secondary': '#27272a',
    'color-text-tertiary': '#27272a',
    'color-text-foreground': '#fff',
    'color-ticket-background-light': '#EFEFEF',
    background: '0 0% 100%',
  },
  Tripbng: {
  'color-primary-default': '#FF8E00',
  'color-primary-light': '#FF8E0038',
  'color-background': '#f3f4f8',
  'color-secondary-default': '#125C9C',
  'color-secondary-light': '#125c9c4b',
  'color-tertiary-default': '#484848',
  'color-tab-background': '#FF8E00',
  'color-tertiary-light': '#eeeeee',
  'color-dark': '#000',
  'color-negative': '#ffcfcc',
  'color-border-light': '#c6c6c6',
  'color-warning': '#fff6c4',
  'color-positive': '#d9fdc1',
  'color-info': '#c6e8fa',
  'color-overlay': 'rgba(0, 0, 0, 0.05)',
  'color-text-primary': '#252525',
  'color-text-secondary': '#27272a',
  'color-text-tertiary': '#27272a',
  'color-text-foreground': '#fff',
  'color-ticket-background-light': '#EFEFEF',
  background: '0 0% 100%',
  },
};
